import styled from 'styled-components'
import { Button } from '../../../commons/Button'
import { Link } from 'react-router-dom'
import Icon from '../../../commons/Icon'

export const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  max-width: 16rem;
  max-height: 16rem;
  min-height: 16rem;
  background: #ffffff;
  box-shadow: 0px 3px 15px #eaecf1;
  border-radius: 5px;

  @media ${({ theme }) => theme.screens.xs} {
    display: none;
  }
`

export const Image = styled.img`
  @media ${({ theme }) => theme.minScreens.lg} {
    max-height: 100%;
    min-height: 16rem;
    margin: 0 auto;
    object-fit: contain;
  }
`

export const ProductInformationWrapper = styled.div`
  flex: 1;
  padding: 0 1.5rem;
`

export const ProductInformation = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4rem;

  @media ${({ theme }) => theme.screens.md} {
    gap: 1rem;
  }

  @media ${({ theme }) => theme.screens.xs} {
    width: 100%;
    flex-wrap: wrap;
  }
`

export const ProductInformationOnLeft = styled.div``

export const ProductCode = styled.div`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize.xs};
  line-height: 1.4rem;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
  margin-bottom: 0.5rem;
`

export const ProductName = styled.span`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 2.2rem;
  display: flex;
  align-items: center;
  letter-spacing: -0.2px;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.colors.primary.default};
`

export const ProductMultiplicationFactor = styled.small``

export const ProductCharacteristics = styled.div`
  ul {
    display: flex;
    li {
      margin-right: 3.5rem;
      margin-bottom: 0.5rem;
      font-weight: 400;
      font-size: ${({ theme }) => theme.fontSize.xs};
      line-height: 1.4rem;
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.colors.mono.greyDarker};
      position: relative;
    }
  }
`

export const ProductInformationOnMid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4rem;
  margin-left: auto;
  @media ${({ theme }) => theme.screens.sm} {
    margin: 0 auto;
    justify-content: center;
  }
`

export const ProductInformationOnRight = styled.div`
  display: flex;
  align-items: center;
  gap: 4rem;
  @media ${({ theme }) => theme.screens.sm} {
    margin: 0 auto;
    justify-content: center;
  }

  @media ${({ theme }) => theme.screens.xs} {
    display: none;
  }
`

export const ProductQuantityWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ProductQuantityButton = styled.button`
  width: 32px;
  height: 32px;
  font-size: 30px;
  background: ${({ theme }) => theme.colors.mono.grey};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
`

export const ProductQuantityField = styled.input`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 2.2rem;
  text-align: center;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.colors.mono.black};
  border: none;
  max-width: 60px;
  transition: all 0.3s ease;
  height: 32px;
  border-radius: 32px;
  &:hover {
    background: ${({ theme }) => theme.colors.mono.greyLight};
  }
`

export const ProductTotalValue = styled.div`
  display: flex;
  align-items: flex-end;
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 2.2rem;
  letter-spacing: -0.3px;
  color: ${({ theme }) => theme.colors.primary.default};
`

export const ProductValuesWrapper = styled.div``

export const ProductValueDescription = styled.div`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize.xs};
  line-height: 1.4rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
  margin-bottom: 1rem;

  @media ${({ theme }) => theme.screens.md} {
    margin-bottom: 0;
  }
`

export const ProductValue = styled.div`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 1.7rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.mono.black};
`

export const ProductInformationOnBottom = styled.div`
  min-height: 44px;
  background: ${({ theme }) => theme.colors.mono.greyLight};
  border-radius: 5px;
  margin-top: 10px;
  padding: 12px;
`

export const ProductCommentWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ProductCommentLabel = styled.label`
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize.sm};
  line-height: 1.7rem;
  color: ${({ theme }) => theme.colors.mono.greyDarker};
  margin-left: 10px;
`

export const ProductActivateCommentInput = styled.input`
  width: 2rem;
  height: 2rem;
`

export const ProductCommentTextarea = styled.textarea`
  margin-top: 10px;
  min-height: 9.6rem;
  background: #ffffff;
  border: 2px solid ${({ theme }) => theme.colors.mono.greyDark};
  border-radius: 6px;
  padding: 12px;
  &:focus,
  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.mono.greyDark};
    outline: none;
  }
`

export const CatalogCartProduct = styled.li`
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1.5px solid ${({ theme }) => theme.colors.mono.greyLight};

  @media ${({ theme }) => theme.minScreens.md} {
    padding: 1.5rem;
  }
`

export const CartDeleteProductBtn = styled.button`
  width: 2.4rem;
  height: 2.4rem;
  color: ${({ theme }) => theme.colors.mono.greyDarker};

  &:hover {
    color: ${({ theme }) => theme.colors.primary.default};
  }

  @media ${({ theme }) => theme.screens.xs} {
    margin-left: 1.5rem;
  }
`
export const CartIcon = styled(Icon)``


// ----------------- MOBILE -----------------

export const MobileLayout = styled.div`
  width: 100%;
  display: none;
  flex-wrap: wrap;
  @media ${({ theme }) => theme.screens.xs} {
    display: flex;
  }
`

export const MobileImageWrapper = styled(ImageWrapper)`
 @media ${({ theme }) => theme.screens.xs} {
    display: flex;
    max-width: 10rem;
    max-height: 10rem;
    min-height: 10rem;
  }
`

export const MobileProductInformationOnRight = styled(ProductInformationOnRight)`
  @media ${({ theme }) => theme.screens.xs} {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`